import agenda_demo from "../../img/agenda_demo_home.png";

const AgendaDemo = () => {
    return (
        <div className="w-full mb-10 lg:pt-10 ">
            <div className="  w-11/12 md:w-5/6 xl:w-4/5 mx-auto bg-[#029DE0] bg-opacity-10 rounded-lg flex flex-col-reverse md:flex-row justify-start items-center ">
                <div className="md:w-1/2 h-full w-full relative  flex md:justify-end justify-center">
                    <img
                        src={agenda_demo}
                        alt="agenda demo"
                        className=" 2xl:w-[600px] lg:w-[550px] md:w-[500px] w-[360px] pointer-events-none select-none"
                    />
                </div>
                <div className="md:w-1/2 w-full flex flex-col py-10">
                    <div className="2xl:text-4xl xl:text-3xl lg:text-2xl md:text-xl text-lg font-bold mx-auto md:mx-0 sm:w-2/3 text-center w-11/12 md:text-left">
                        Agenda tu demo hoy y transforma la gestión de tu
                        propiedad con BluStay
                    </div>

                    <div
                        onClick={() => {
                            window.open(
                                "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                            );
                        }}
                        className="w-fit mx-auto md:mx-0  flex justify-center items-center gap-2 rounded-lg text-[#071829] px-4 py-2 bg-gradient-to-r from-[#C3EA43] to-[#E3FF89] 2xl:mt-10 mt-7 hover:scale-105 cursor-pointer xl:text-base text-sm  "
                    >
                        Agenda tu demo
                        <svg
                            className="text-[#071829]"
                            width="12"
                            height="13"
                            viewBox="0 0 16 17"
                            fill="071829"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5.375 16.125C5.05859 16.125 4.77734 16.0195 4.56641 15.8086C4.10938 15.3867 4.10938 14.6484 4.56641 14.2266L10.5078 8.25L4.56641 2.30859C4.10938 1.88672 4.10938 1.14844 4.56641 0.726562C4.98828 0.269531 5.72656 0.269531 6.14844 0.726562L12.8984 7.47656C13.3555 7.89844 13.3555 8.63672 12.8984 9.05859L6.14844 15.8086C5.9375 16.0195 5.65625 16.125 5.375 16.125Z"
                                fill="071829"
                            />
                        </svg>{" "}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgendaDemo;
